import { makeStyles, tokens, Image, Text, Button } from "@fluentui/react-components";
import React, { useContext } from 'react';
import { FormattedMessage } from "react-intl";

import { HostType } from "@tdp/common/host";
import { settingsSlice } from "@tdp/common/settings";
import { DeveloperPortalRootContext, loadBuildConfig, useSelector } from "@tdp/core";

export const useFeatureUnavailableStyles = makeStyles({
  pageContainer: {
    backgroundColor: tokens.colorNeutralBackground1,
    color: tokens.colorBrandBackgroundInverted,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    boxSizing: 'border-box',
    height: '100%',
    width: '100%',
    overflowY: 'auto',
    padding: "18px",
    gap: '1.5rem',
  },
  empty: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '12px',
    flexDirection: 'column',
    flexGrow: 1,
    color: tokens.colorNeutralForeground1,
  },
  text: {
    maxWidth: '700px',
    textAlign: 'center',
  },
})

const featureUnavailableAssets = {
  clientSwitch: `/images/illustrations/client-switch.png`,
};

export const UnavilableFeatureClientSwitch: React.FC<{ featureName: string }> = ({ featureName }) => {
  const classes = useFeatureUnavailableStyles();

  const appRunContext = useSelector(settingsSlice.selectors.appRunContext);
  const { services: { logger } } = useContext(DeveloperPortalRootContext);

  const buildConfig = loadBuildConfig();
  const baseUrl = (buildConfig.api as { baseUrl: string }).baseUrl;
  let clientRedirectionUrl =
    'https://dev-int.teams.cloud.dev.microsoft/?client-preference=classic';
  if (baseUrl === 'https://dev.teams.microsoft.com/api') {
    clientRedirectionUrl =
      'https://dev.teams.cloud.microsoft/?client-preference=classic';
  }

  const onClicKhandler = () => {
    logger.logUserBi({ telemetryMarker: 'user-action-feature-unavailable-switch-to-old-client-triggered', message: `For feature: ${featureName}, User opted to switch to old client: ${clientRedirectionUrl}, from host: ${appRunContext?.host}` });

    if (appRunContext?.host === HostType.TEAMS) {
      window.open(clientRedirectionUrl, '_blank');
    } else {
      window.location.href = clientRedirectionUrl;
    }
  };

  return (
    <div className={classes.empty}>
      <Image
        src={featureUnavailableAssets.clientSwitch}
        width={256}
        alt="Illustration for client switch"
      />
      <Text weight="bold">
        <FormattedMessage
          defaultMessage="Feature Unavailable"
          description={
            'Message displayed when there is no data available for analytics'
          }
        />
      </Text>
      <Text className={classes.text} id="unavailable-feature-switch-description">
        <FormattedMessage
          defaultMessage="You are currently using the new Developer Portal. To access {featureName}, switch to the previous version."
          description={
            'The message shown in the app dashboard when the tenant admin has not provided consent for LOB apps.'
          }
          values={{ featureName }}
        />
      </Text>
      <Button appearance='primary' onClick={onClicKhandler}
        aria-labelledby="unavailable-feature-switch-description">
        {appRunContext?.host === HostType.TEAMS ?
          <FormattedMessage
            defaultMessage='Go to previous version'
            description='Top Banner button text for client switch'
          /> :
          <FormattedMessage
            defaultMessage='Switch to previous version'
            description='Top Banner button text for client switch'
          />
        }
      </Button>
    </div>
  );
};